"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

/**
 * A component is simply a React style component with props types and default props.
 * @module Component
 */
var Component = /*#__PURE__*/function () {
  /**
   * Prop types for validation
   * @static
   */

  /**
   * Default props
   * @static
   */
  function Component() {
    var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    _classCallCheck(this, Component);

    this.props = props;
  }
  /**
   * Renders the component
   * @static
   * @function
   * @abstract
   */


  _createClass(Component, [{
    key: "render",
    value: function render() {
      return null;
    }
  }]);

  return Component;
}();

exports["default"] = Component;

_defineProperty(Component, "propTypes", {});

_defineProperty(Component, "defaultProps", {});


//////////////////
// WEBPACK FOOTER
// ./node_modules/@harvest-profit/doc-flux/dist/Component.js
// module id = 6
// module chunks = 0